export const spendReview = $state({
  open: false,
  title: '',
  quote: null,
  request: null,
  balance: null,
  discountBps: 0
});

const pendingReviews = [];
let activeReview = null;
const listeners = new Set();

export function onSpendReviewChange(listener) {
  listeners.add(listener);
  listener(spendReview.open);
  return () => listeners.delete(listener);
}

function showNextReview() {
  if (activeReview || !pendingReviews.length) return;
  activeReview = pendingReviews.shift();
  Object.assign(spendReview, activeReview.details, { open: true });
  listeners.forEach(listener => listener(true));
}

export function reviewSpend(details) {
  return new Promise((resolve, reject) => {
    pendingReviews.push({ details, resolve, reject });
    showNextReview();
  });
}

export function finishSpendReview(approved) {
  if (!activeReview) return;
  const current = activeReview;
  activeReview = null;
  spendReview.open = false;
  if (approved) current.resolve(true);
  else {
    const error = new Error('Generation canceled. No new work was submitted.');
    error.code = 'COST_APPROVAL_CANCELED';
    error.request = current.details.request;
    current.reject(error);
  }
  showNextReview();
  if (!activeReview) listeners.forEach(listener => listener(false));
}
